require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./admission-et-aide-lepfl-2-6.json") })
        }
      }, "path---admission-et-aide-lepfl-2-6");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---admission-et-aide-lepfl-2-6!./.cache/json/admission-et-aide-lepfl-2-6.json
// module id = 319
// module chunks = 231608221292675